export enum WorkflowActionType {
  availableSteps = 'availableSteps',
  move = 'move',
  takeOwnership = 'takeOwnership',
  create = 'create',
}
